import { SocketMatchmakingSend } from '../../../../../../../shared/scripts/socket/SocketMatchmakingSend.ts';
import { UIMMatchmakingSearching1v1View } from './UIMMatchmakingSearching1v1View.ts';
import { UIMMatchmakingSearchingClassic4PView } from './UIMMatchmakingSearchingClassic4PView.ts';
import { UIMMatchmakingSearchingCnKView } from './UIMMatchmakingSearchingCnKView.ts';
import { UIMMatchmakingActionsController } from '../UIMMatchmakingActionsController.ts';
import { isBotMatchType, MatchmakingMatchTypes } from '@colonist/game-base-types';
import { getMatchTypeEligibilityAndCreatePopup, startBotGame } from '../../../../../../../shared/scripts/matchmaking/MatchmakingUtilsClient.ts';
import { ClientUserState } from '../../../../../../../shared/scripts/ClientUserState.ts';
import { UIMMatchmakingSearchingShuffleView } from './UIMMatchmakingSearchingShuffleView.ts';
import { UIMMatchmakingSearchingRush4PView } from './UIMMatchmakingSearchingRush4PView.ts';
export class UIMMatchmakingController {
    async startGame(matchType, botMapSetting) {
        if (isBotMatchType(matchType)) {
            startBotGame(matchType, botMapSetting);
            return;
        }
        const matchmakingType = matchType;
        const { isEligible, createPopup } = getMatchTypeEligibilityAndCreatePopup(matchmakingType);
        createPopup === null || createPopup === void 0 ? void 0 : createPopup();
        if (!isEligible) return;
        await ClientUserState.requireUser();
        await this.matchmakingActionsController.fetchRankedState();
        switch(matchmakingType){
            case MatchmakingMatchTypes.UnrankedClassic1v1:
            case MatchmakingMatchTypes.RankedClassic1v1:
                this.matchmakingSearchingView = new UIMMatchmakingSearching1v1View(this, matchmakingType);
                break;
            case MatchmakingMatchTypes.UnrankedClassic4P:
            case MatchmakingMatchTypes.RankedClassic4P:
                this.matchmakingSearchingView = new UIMMatchmakingSearchingClassic4PView(this, matchmakingType);
                break;
            case MatchmakingMatchTypes.RankedCitiesAndKnights4P:
                this.matchmakingSearchingView = new UIMMatchmakingSearchingCnKView(this);
                break;
            case MatchmakingMatchTypes.RankedRush4P:
                this.matchmakingSearchingView = new UIMMatchmakingSearchingRush4PView(this);
                break;
            case MatchmakingMatchTypes.UnrankedShuffle:
                this.matchmakingSearchingView = new UIMMatchmakingSearchingShuffleView(this);
                break;
            default:
                return;
        }
        this.matchmakingActionsController.sendFindGameMessageToServer(matchmakingType);
    }
    stopSearching() {
        var _this_matchmakingSearchingView;
        (_this_matchmakingSearchingView = this.matchmakingSearchingView) === null || _this_matchmakingSearchingView === void 0 ? void 0 : _this_matchmakingSearchingView.removeFromDOM();
        SocketMatchmakingSend.sendCancelFindGame();
    }
    removeSearchingScreen() {
        var _this_matchmakingSearchingView;
        (_this_matchmakingSearchingView = this.matchmakingSearchingView) === null || _this_matchmakingSearchingView === void 0 ? void 0 : _this_matchmakingSearchingView.removeFromDOM();
    }
    updateMatchmakingStatus(matchmakingStatusUpdate) {
        var _this_matchmakingSearchingView;
        (_this_matchmakingSearchingView = this.matchmakingSearchingView) === null || _this_matchmakingSearchingView === void 0 ? void 0 : _this_matchmakingSearchingView.updateStatus(matchmakingStatusUpdate);
    }
    constructor(){
        this.matchmakingActionsController = new UIMMatchmakingActionsController();
    }
}
